
import { Component, OnInit, OnDestroy, Signal, signal } from '@angular/core';
import { Subscription } from 'rxjs';
import { SyncPricesCartService } from '../../../../core/service/sync-prices-cart/sync-prices-cart.service';
import { StorageProducts } from '../../../../core/service/cart-apis/interfaces/cart.interface';
import { ShopCartService } from '../../../../shared/components/shop-cart/service/shop-cart.service';
import { ResumenPedidoService } from './service/resumen-pedido.service';
import { Store } from '@ngrx/store';
import { ShippingState } from '../../../../store/shipping/shipping.reducer';
import { BalanceModel } from '../../../perfil-user/store/balance.model';
import { toSignal } from '@angular/core/rxjs-interop';
import { CalculateTotalService } from '../../../../core/service/calculateTotal/calculate-total.service';
import { PrePurchaseService } from '../../../../core/service/pre-purchase/pre-purchase.service';
import { CartService } from '../../../../core/service/cart-apis/cart.service';


@Component({
  selector: 'detail-orden-checkout-resumen-pedido',
  imports: [],
  templateUrl: './resumen-pedido.component.html',
  styleUrl: './resumen-pedido.component.css',

})
export class ResumenPedidoComponent implements OnInit, OnDestroy {


  total: any = 0;
  shippingCost: number = 0;
  distance: number = 0;
  totalCost: number = 0;
  percent: number | null = null;
  mountForDelivery: number = 0;
  quantity: number = 0;
  isShippingFree: boolean = false;
  tip: number = 0;
  balance: Signal<string | undefined>;
  descountBalanceC = signal(0);
  tarifaBase = signal(0);
  tarifaServicio = signal(0);

  // Suscripciones
  private subscriptions: Subscription[] = [];

  constructor(
    private store: Store<{ shipping: ShippingState, balance: BalanceModel }>,
    private resumenPedidoService: ResumenPedidoService,
    private prePurchaseService: PrePurchaseService,
    private cartService: CartService,

  ) {
    this.balance = toSignal(this.store.select(state => state.balance.balance));
  }

  ngOnInit(): void {
    // Suscribirse a los valores del store
    this.subscriptions.push(
      this.store.select(state => state.shipping.shippingCost)
        .subscribe(cost => this.shippingCost = Number(cost)),

      this.store.select(state => state.shipping.kmDistance)
        .subscribe(distance => this.distance = Number(distance)),

      this.store.select(state => state.shipping.totalCost)
        .subscribe(total => {
          this.totalCost = Number(total);
        }),

      this.store.select(state => state.shipping.deliveryPercent)
        .subscribe(percent => this.percent = Number(percent)),

      this.store.select(state => state.shipping.mountForDelivery)
        .subscribe(mount => this.mountForDelivery = Number(mount)),

      // Suscripción para la propina
      this.resumenPedidoService.getTip$()
        .subscribe(tip => {
          this.tip = tip;
          this.updateAppliedDiscount();
        }),
      // this.store.select(state => state.shipping.tarifaBase).subscribe(tarifaBase => {
      //   this.tarifaBase.set(Number(tarifaBase))
      // }),
      this.store.select(state => state.shipping.tarifaServicio).subscribe(tarifaServicio => {
        this.tarifaServicio.set(Number(tarifaServicio))
      }),

      // Suscripción para el costo total del carrito
      this.cartService.getTotalPurchase().subscribe({
        next: (cost) => {
          this.total = cost;
          this.updateAppliedDiscount();
        },
        error: (error) => {
          console.error('Error al obtener el costo del carrito:', error);
        }
      })
    );

    // Cargar datos iniciales una sola vez
    this.loadInitialData();
  }

  private loadInitialData(): void {
    // Cargar coordenadas y costo de productos una sola vez
    const coordinatesSub = this.prePurchaseService.getCoordinates().subscribe(coordinates => {
      if (coordinates) {
        const costSub = this.cartService.getCostProducts().subscribe({
          next: (cost) => {
            this.total = cost;
            this.updateAppliedDiscount();
          },
          error: (error) => {
            console.error('Error al obtener el costo del carrito:', error);
          }
        });
        this.subscriptions.push(costSub);
      }
    });
    this.subscriptions.push(coordinatesSub);
  }

  calculateTotal(): number {
    // Calcular el subtotal correctamente
    const subtotal = this.isShippingFree ?
      this.total + this.tip :
      this.total + this.shippingCost + this.tip + this.tarifaServicio();

    if (this.balance() === undefined || this.balance() === null || this.balance() === '0.00') {
      // Sin balance disponible, retornar el subtotal
      return +subtotal.toFixed(2);
    } else {
      // Con balance disponible, aplicar el descuento
      const availableBalance = parseFloat(this.balance() as string);

      // Aplica el balance disponible al subtotal
      const finalTotal = Math.max(0, subtotal - availableBalance);
      return +finalTotal.toFixed(2);
    }

  }
  updateAppliedDiscount(): void {
    const subtotal = this.isShippingFree ?
      this.total + this.tip :
      this.total + this.shippingCost + this.tip  + this.tarifaServicio();

    const possibleDiscount = Number(this.balance());

    if (possibleDiscount >= subtotal) {
      // Si el balance es mayor que el subtotal, solo descontamos el subtotal
      this.descountBalanceC.set(subtotal);
    } else {
      // Si el balance es menor, descontamos todo el balance disponible
      this.descountBalanceC.set(possibleDiscount);
    }
  }

  // Función para obtener el valor del descuento (sin modificarlo)
  getAppliedDiscount(): Signal<number> {
    return this.descountBalanceC;
  }

  ngOnDestroy(): void {
    // Cancelar todas las suscripciones para evitar fugas de memoria
    this.subscriptions.forEach(sub => sub.unsubscribe());
  }

}
